"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var react_sortable_hoc_1 = require("react-sortable-hoc");
// Relements
var modal_1 = __importDefault(require("relements/build/esm/overlays/modal"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var text_2 = __importDefault(require("relements/build/esm/input/text"));
var radio_1 = __importDefault(require("relements/build/esm/input/radio"));
var tooltip_1 = __importDefault(require("relements/build/esm/overlays/tooltip"));
var toggle_1 = __importDefault(require("relements/build/esm/input/toggle"));
// Actions
var BotActions_1 = require("@src/actions/BotActions");
// Components
var ChannelItem_1 = __importDefault(require("./components/ChannelItem"));
var TriggerRule_1 = __importDefault(require("./components/TriggerRule"));
var PreviewAndEdit_1 = __importDefault(require("./components/PreviewAndEdit"));
// Icons
var BackArrow_svg_1 = __importDefault(require("./icons/BackArrow.svg"));
var AddIcon_svg_1 = __importDefault(require("./icons/AddIcon.svg"));
var ErrorInfo_svg_1 = __importDefault(require("./icons/ErrorInfo.svg"));
var WarningInfo_svg_1 = __importDefault(require("./icons/WarningInfo.svg"));
// Constants
var promptTrigger_1 = require("@src/containers/BusinessManager/const/promptTrigger");
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var constants_1 = require("./constants");
var constants_2 = require("./components/PreviewAndEdit/constants");
var StyledIcon = styled_components_1["default"](icon_1["default"])({
    width: 24,
    height: 24,
    marginRight: 24,
});
var HeaderTextWrapper = styled_components_1["default"](text_1["default"])(function (props) { return ({
    color: props.theme.colors.black.haptik,
}); });
var MandatoryTextWrapper = styled_components_1["default"](text_1["default"])(function (props) { return ({
    marginLeft: props.theme.space.sm,
    color: props.theme.colors.grey.dark,
}); });
var NameInputWrapper = styled_components_1["default"](text_2["default"])({
    width: '458px',
});
var SectionWrapper = styled_components_1["default"](box_1["default"])({
    padding: 0,
    marginTop: 24,
    flexDirection: 'column',
});
var NewRuleButtonWrapper = styled_components_1["default"](button_1["default"])(function (props) { return ({
    display: 'flex',
    alignItems: 'center',
    width: 136,
    borderRadius: props.theme.radii.sm,
    padding: 8,
    margin: '8px 0px 0px 0px',
}); });
var AddIconWrapper = styled_components_1["default"](icon_1["default"])({
    marginRight: 7,
});
var ActiveStatusWrapper = styled_components_1["default"](box_1["default"])({
    padding: '0px',
    justifyContent: 'space-between',
    margin: '24px 24px 0px 0px',
});
var SaveButtonWrapper = styled_components_1["default"](button_1["default"])({
    width: 142,
    height: 42,
});
var MessageBoxWrapper = styled_components_1["default"](box_1["default"])(function (props) { return ({
    background: props.error
        ? props.theme.colors.red.pastel
        : props.theme.colors.yellow.pastel,
    border: "1px solid " + (props.error ? props.theme.colors.red.haptik : props.theme.colors.yellow.deep),
    borderRadius: props.theme.radii.sm,
    padding: 18,
    marginBottom: 24,
}); });
var MessageTextWrapper = styled_components_1["default"](text_1["default"])(function (props) { return ({
    color: props.error
        ? props.theme.colors.red.haptik
        : props.theme.colors.yellow.dark,
}); });
var MessageIconWrapper = styled_components_1["default"](icon_1["default"])({
    width: 20,
    height: 20,
    marginRight: 12,
});
var DocumentationLink = styled_components_1["default"].a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 400;\n  ", "\n  text-decoration: none;\n  margin-top: 6px;\n  ", "\n"], ["\n  font-weight: 400;\n  ", "\n  text-decoration: none;\n  margin-top: 6px;\n  ", "\n"])), function (props) { return "font-size: " + props.theme.fontSizes[3] + "px;"; }, function (props) { return "color: " + props.theme.colors.blue.haptik + ";"; });
var TooltipText = styled_components_1["default"](text_1["default"])(function (props) { return ({
    color: props.theme.colors.grey.soft,
}); });
var StyledUl = styled_components_1["default"].ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) { return "\n      margin: " + props.theme.space.zero + "px;\n      padding: " + props.theme.space.zero + "px;\n    "; });
var SortableChannelItem = react_sortable_hoc_1.SortableElement(ChannelItem_1["default"]);
var SortableChannelsWrapper = react_sortable_hoc_1.SortableContainer(function (_a) {
    var children = _a.children;
    return react_1["default"].createElement(StyledUl, null, children);
});
// initial state
var initialState = {
    id: -1,
    name: '',
    priority: -1,
    active: true,
    rules: {
        clause: 'AND',
        rule_list: [
            {
                variable: 'page_url',
                operator: 'eq',
                value: '',
                meta: {},
            },
        ],
    },
    social_prompt: {
        header: 'Help is everywhere!',
        body: 'Get help on any of these social platforms',
        channels: [
            {
                type: 'whatsapp',
                enabled: false,
                text: 'Chat on WhatsApp',
            },
            {
                type: 'messenger',
                enabled: false,
                text: 'Chat on Messenger',
            },
            {
                type: 'instagram',
                enabled: false,
                text: 'Chat on Instagram',
            },
        ],
    },
    variants: [],
};
// Reducer
function reducer(state, action) {
    switch (action.type) {
        case constants_1.ActionTypes.UPDATE_NAME:
            return __assign(__assign({}, state), { name: action.data });
        case constants_1.ActionTypes.UPDATE_RULES:
            return __assign(__assign({}, state), { rules: action.data });
        case constants_1.ActionTypes.UPDATE_CHANNELS:
            return __assign(__assign({}, state), { social_prompt: action.data });
        case constants_1.ActionTypes.UPDATE_ACTIVE_STATUS:
            return __assign(__assign({}, state), { active: action.data });
        default:
            return state;
    }
}
var SocialTriggerModal = function (_a) {
    var isModalActive = _a.isModalActive, setIsModalActive = _a.setIsModalActive, setIsCreateModalActive = _a.setIsCreateModalActive, totalNumberOfTriggers = _a.totalNumberOfTriggers, onChange = _a.onChange, data = _a.data, omniChannelWidget = _a.omniChannelWidget;
    var _b = react_1["default"].useReducer(reducer, cloneDeep_1["default"](data) || cloneDeep_1["default"](initialState)), state = _b[0], dispatch = _b[1];
    var _c = react_1.useState(cloneDeep_1["default"](data) || cloneDeep_1["default"](initialState)), existingData = _c[0], setExistingData = _c[1];
    var _d = react_1.useState(false), isPreviewAndEditEdited = _d[0], setIsPreviewAndEditEdited = _d[1];
    var modalRef = react_1.useRef();
    var id = state.id, name = state.name, priority = state.priority, active = state.active, rules = state.rules, variants = state.variants, social_prompt = state.social_prompt;
    var clauseOption = constants_1.CLAUSE_OPTIONS.filter(function (opt) { return opt.value === rules.clause; })[0];
    // When user clicks on Back Arrow available in Header
    var onBackArrowClick = function () {
        setIsModalActive(false);
        setIsCreateModalActive(true);
    };
    // Header of the Modal
    var renderHeader = function () {
        return (react_1["default"].createElement(box_1["default"], { padding: "7px 0px" },
            !data && react_1["default"].createElement(StyledIcon, { src: BackArrow_svg_1["default"], onClick: onBackArrowClick }),
            react_1["default"].createElement(HeaderTextWrapper, { variant: "h2.semi-bold" }, "Omnichannel Bot Prompts")));
    };
    // Footer of the Modal
    var renderFooter = function () {
        var isSaveEnabled = isSaveButtonEnabled();
        return (react_1["default"].createElement(box_1["default"], { padding: "0px", marginLeft: "auto" },
            react_1["default"].createElement(SaveButtonWrapper, { themed: true, variant: !isSaveEnabled ? 'disabled' : 'primary', disabled: !isSaveEnabled, onClick: function () {
                    if (validateData()) {
                        onChange({
                            id: id,
                            name: name,
                            priority: priority === -1 ? totalNumberOfTriggers : priority,
                            active: active,
                            social_prompt: social_prompt,
                            rules: rules,
                            variants: variants,
                            trigger_type: 1,
                        });
                        setIsModalActive(false);
                    }
                } }, "Save")));
    };
    // Renders the message for channels which are not configured
    var renderMessage = react_1["default"].useCallback(function () {
        var channelNotConfigured = omniChannelWidget === null || omniChannelWidget === void 0 ? void 0 : omniChannelWidget.filter(function (channel) { return !channel.enabled; });
        // When no changes are configured
        if ((channelNotConfigured && channelNotConfigured.length === 3) ||
            (omniChannelWidget === null || omniChannelWidget === void 0 ? void 0 : omniChannelWidget.length) === 0) {
            return (react_1["default"].createElement(MessageBoxWrapper, { error: true },
                react_1["default"].createElement(MessageIconWrapper, { src: ErrorInfo_svg_1["default"] }),
                react_1["default"].createElement(box_1["default"], { padding: "0px", flexDirection: "column" },
                    react_1["default"].createElement(MessageTextWrapper, { variant: "body.lg", error: true }, "No other channel has been enabled for this bot yet. Learn how to enable social channels."),
                    react_1["default"].createElement(DocumentationLink, { href: "https://docs.haptik.ai/how-to-enable-omnichannel-bot-prompts#why-am-i-seeing-few-channels-as-greyed-out-0", target: "_blank" }, "See documentation"))));
        }
        else if (channelNotConfigured && channelNotConfigured.length > 0) {
            // When one or more channels are not configured.
            // Eg: When only one channel is not configured then the length of channelNotConfigured will be 1.
            return (react_1["default"].createElement(MessageBoxWrapper, null,
                react_1["default"].createElement(MessageIconWrapper, { src: WarningInfo_svg_1["default"] }),
                react_1["default"].createElement(box_1["default"], { padding: "0px", flexDirection: "column" },
                    react_1["default"].createElement(MessageTextWrapper, { variant: "body.lg" },
                        constants_1.SOCIAL_CHANNELS.TITLE[channelNotConfigured[0].type],
                        ' ',
                        channelNotConfigured.length === 2 &&
                            "and " + constants_1.SOCIAL_CHANNELS.TITLE[channelNotConfigured[1].type],
                        ' ',
                        "can not be added since",
                        ' ',
                        channelNotConfigured.length === 1 ? 'it has' : 'they have',
                        " not been configured in bot settings."),
                    react_1["default"].createElement(DocumentationLink, { href: "https://docs.haptik.ai/en_US/customisations/configure-channel-switching", target: "_blank" }, "See documentation"))));
        }
    }, [omniChannelWidget]);
    // Mandatory Char Symbol
    var renderMandatoryChar = function (isSectionChannel) {
        if (isSectionChannel === void 0) { isSectionChannel = false; }
        return (react_1["default"].createElement(tooltip_1["default"], { themed: true, position: "TOP", tooltip: react_1["default"].createElement(box_1["default"], { padding: "16px" },
                react_1["default"].createElement(TooltipText, { variant: "body.lg" }, isSectionChannel
                    ? 'Select at least one social channel to proceed.'
                    : 'Bot Prompt Name is required field.')) },
            react_1["default"].createElement(MandatoryTextWrapper, { variant: "h1.semi-bold" }, "*")));
    };
    // When user selects or unselects the social channel
    var onChannelChangeHandler = function (currentChannel) {
        var updatedSocialPrompt = social_prompt;
        updatedSocialPrompt.channels.map(function (channel) {
            if (channel.type === currentChannel)
                channel.enabled = !channel.enabled;
        });
        // Default Text for Header and Body when the trigger is new,
        // Once the Preview and Edit Section is edited then it will not change according to channel selection.
        if (id === -1 && !isPreviewAndEditEdited) {
            var channelsEnabled = social_prompt.channels.filter(function (channel) { return channel.enabled; });
            updatedSocialPrompt.header =
                channelsEnabled.length === 1
                    ? "Say Hi on " + (channelsEnabled[0].type === constants_1.SOCIAL_CHANNELS.KEYS.messenger
                        ? 'Messenger'
                        : constants_1.SOCIAL_CHANNELS.TITLE[channelsEnabled[0].type])
                    : 'Help is everywhere!';
            updatedSocialPrompt.body =
                channelsEnabled.length === 1
                    ? 'Instant answers to your queries are now just a click away.'
                    : 'Get help on any of these social platforms';
        }
        dispatch({
            type: constants_1.ActionTypes.UPDATE_CHANNELS,
            data: updatedSocialPrompt,
        });
    };
    // Handle data change for Preview and Edit Section.
    var onSocialPromptDataChange = function (type, value) {
        setIsPreviewAndEditEdited(true);
        var socialPromptData = social_prompt;
        switch (type) {
            case constants_2.CONSTANTS.HEADING:
                socialPromptData.header = value;
                break;
            case constants_2.CONSTANTS.BODY:
                socialPromptData.body = value;
            case constants_2.CONSTANTS.CHANNEL:
                socialPromptData.channels.map(function (channel, index) {
                    if (channel.type === value.type) {
                        socialPromptData.channels[index].text = value.value;
                    }
                });
        }
        dispatch({
            type: constants_1.ActionTypes.UPDATE_CHANNELS,
            data: socialPromptData,
        });
    };
    // User clicks on Add Prompt Rules
    var onAddRule = function () {
        var defaultVariable = 'page_url';
        var defaultVariableType = promptTrigger_1.SUPPORTED_VARIABLES[defaultVariable].type;
        var newRule = {
            variable: defaultVariable,
            operator: promptTrigger_1.SUPPORTED_OPERATORS_BY_TYPE[defaultVariableType][0],
            value: '',
            meta: {},
        };
        dispatch({
            type: constants_1.ActionTypes.UPDATE_RULES,
            data: {
                clause: rules.clause,
                rule_list: __spreadArrays(rules.rule_list, [newRule]),
            },
        });
    };
    // Change Handler for Existing Rule
    var onChangeRule = function (index, key, value) {
        var updatedRulesList = __spreadArrays(rules.rule_list);
        updatedRulesList[index][key] = value;
        dispatch({
            type: constants_1.ActionTypes.UPDATE_RULES,
            data: {
                clause: rules.clause,
                rule_list: updatedRulesList,
            },
        });
    };
    var onActiveChange = function () {
        dispatch({ type: constants_1.ActionTypes.UPDATE_ACTIVE_STATUS, data: !active });
    };
    // Remove Handler for Prompt Rules
    var onRemove = function (indexToRemove) {
        var rulesList = rules.rule_list.filter(function (rule, index) { return index !== indexToRemove; });
        if (rulesList.length === 0) {
            BotActions_1.createAlert('There should be atleast 1 rule', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        dispatch({
            type: constants_1.ActionTypes.UPDATE_RULES,
            data: {
                clause: rules.clause,
                rule_list: rulesList,
            },
        });
    };
    // Validates data when user clicks on Save.
    var validateData = function () {
        if (!name) {
            BotActions_1.createAlert('Please enter valid Prompt Name', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return false;
        }
        if (!social_prompt.channels.filter(function (channel) { return channel.enabled; }).length) {
            BotActions_1.createAlert('Please select atleast one Social Channel', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return false;
        }
        var hasEmptyValue = false;
        rules.rule_list.forEach(function (rule) {
            if (rule.variable) {
                var metaKeys = promptTrigger_1.SUPPORTED_VARIABLES[rule.variable].metaKeys;
                metaKeys.forEach(function (metaKey) {
                    if (rule.meta[metaKey.key] === undefined ||
                        rule.meta[metaKey.key] === '') {
                        BotActions_1.createAlert('Please fill appropriate value for the meta field', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        hasEmptyValue = true;
                        return;
                    }
                });
            }
            if (promptTrigger_1.FIXED_VALUE_OPERATORS[rule.operator])
                return;
            if (!rule.value.toString().trim() || !rule.value) {
                BotActions_1.createAlert('Please enter appropriate value for each Prompt Rule', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                hasEmptyValue = true;
                return;
            }
        });
        if (hasEmptyValue)
            return false;
        // Check for Heading Text
        if (social_prompt.header.length > constants_2.CHARACTER_LIMIT.HEADING ||
            social_prompt.header.length === 0) {
            BotActions_1.createAlert('Please enter appropriate value for Heading Text', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return false;
        }
        // Check for Body Text
        if (social_prompt.body.length > constants_2.CHARACTER_LIMIT.BODY ||
            social_prompt.body.length === 0) {
            BotActions_1.createAlert('Please enter appropriate value for Body Text', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return false;
        }
        // Check for Button Text of Selected Social Channels.
        var hasEmptyButtonText = false;
        social_prompt.channels.map(function (channel) {
            if (channel.text.length > constants_2.CHARACTER_LIMIT.CHANNEL[channel.type] ||
                channel.text.length === 0) {
                BotActions_1.createAlert("Please enter appropriate value for " + constants_1.SOCIAL_CHANNELS.TITLE[channel.type] + " Button Text", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                hasEmptyButtonText = true;
                return;
            }
        });
        if (hasEmptyButtonText)
            return false;
        return true;
    };
    // Checks and validates the data to enable or disable the Save Button
    var isSaveButtonEnabled = function () {
        if (existingData) {
            // Name check
            if (existingData.name !== name.trim())
                return true;
            // Number of channels check
            if (existingData.social_prompt.channels.length !==
                social_prompt.channels.length)
                return true;
            // Status check
            if (existingData.active !== active)
                return true;
            // Channels Order Check
            var sameOrder_1 = true;
            social_prompt.channels.map(function (currentChannel, currentChannelIndex) {
                existingData.social_prompt.channels.map(function (existingChannel, existingChannelIndex) {
                    if (currentChannelIndex === existingChannelIndex &&
                        currentChannel.type !== existingChannel.type) {
                        sameOrder_1 = false;
                    }
                });
            });
            if (!sameOrder_1)
                return true;
            // Heading and Body Text Check
            if (social_prompt.header !== existingData.social_prompt.header ||
                social_prompt.body !== existingData.social_prompt.body)
                return true;
            // Channels Check
            var sameChannels_1 = true;
            social_prompt.channels.map(function (currentChannel) {
                if (existingData.social_prompt.channels.filter(function (existingChannel) {
                    return existingChannel.type === currentChannel.type &&
                        (existingChannel.enabled !== currentChannel.enabled ||
                            existingChannel.text !== currentChannel.text);
                }).length)
                    sameChannels_1 = false;
            });
            if (!sameChannels_1)
                return true;
            // Clause Check
            if (existingData.rules.clause !== rules.clause)
                return true;
            // Rules Check - Operator, Value, Variable, Meta
            var sameRules_1 = true;
            rules.rule_list.map(function (currentRule, index) {
                if (!existingData.rules.rule_list.filter(function (existingRule) {
                    return existingRule.operator === currentRule.operator &&
                        existingRule.value.toString().trim() ===
                            currentRule.value.toString().trim() &&
                        existingRule.variable === currentRule.variable;
                }).length)
                    sameRules_1 = false;
                if (existingData.rules.rule_list[index] &&
                    existingData.rules.rule_list[index].meta) {
                    var existingMetaValues = Object.values(existingData.rules.rule_list[index].meta);
                    var currentMetaValues_1 = Object.values(currentRule.meta);
                    existingMetaValues.map(function (value, index) {
                        if (value !== currentMetaValues_1[index])
                            sameRules_1 = false;
                    });
                }
            });
            if (!sameRules_1)
                return true;
            // Number of Rules Check
            if (rules.rule_list.length !== existingData.rules.rule_list.length)
                return true;
        }
        return false;
    };
    // Checks whether the channel is disabled or enabled
    var isChannelDisabled = function (channelType) {
        var isDisabled = true;
        omniChannelWidget &&
            omniChannelWidget.map(function (channel) {
                if (channel.type === channelType && channel.enabled) {
                    isDisabled = false;
                    return;
                }
            });
        return isDisabled;
    };
    var onClose = function () {
        if (isSaveButtonEnabled()) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Discard Changes',
                cancelTitle: 'Cancel',
                title: 'Do you want to discard the changes made in this Trigger?',
                message: 'Changes made for this trigger will be lost.',
                onOk: function () {
                    setIsModalActive(false);
                },
                onCancel: function () { },
                okActionType: 'danger',
            });
        }
        else {
            setIsModalActive(false);
        }
    };
    var sortHandler = function (_a) {
        var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
        // If the old or new index channel is not configured then don't handle the sort.
        var isDisabledChannels = false;
        omniChannelWidget.map(function (widgetChannel) {
            if ((widgetChannel.type === social_prompt.channels[oldIndex].type ||
                widgetChannel.type === social_prompt.channels[newIndex].type) &&
                !widgetChannel.enabled) {
                isDisabledChannels = true;
            }
        });
        if (isDisabledChannels)
            return;
        var updatedSocialPrompt = __assign(__assign({}, social_prompt), { channels: react_sortable_hoc_1.arrayMove(social_prompt.channels, oldIndex, newIndex) });
        dispatch({
            type: constants_1.ActionTypes.UPDATE_CHANNELS,
            data: updatedSocialPrompt,
        });
    };
    // Returns social_prompt with only activated channels (configured + enabled)
    var getActiveChannelsData = function () {
        var social_prompt_data = cloneDeep_1["default"](social_prompt);
        social_prompt_data.channels = social_prompt.channels.filter(function (channel) {
            var isEnabledChannel = false;
            omniChannelWidget.map(function (widgetChannel) {
                if (widgetChannel.type === channel.type) {
                    isEnabledChannel = widgetChannel.enabled && channel.enabled;
                }
            });
            return isEnabledChannel;
        });
        return social_prompt_data;
    };
    return (react_1["default"].createElement(modal_1["default"], { themed: true, active: isModalActive, onClose: onClose, header: renderHeader(), footer: renderFooter(), style: { padding: '0px' }, ref: modalRef },
        react_1["default"].createElement(box_1["default"], { padding: "0px", width: "1200px" },
            react_1["default"].createElement(box_1["default"], { "data-testid": "prompt-edit", padding: "24px 32px 0px 24px", flexDirection: "column", width: "783px", overflowY: "auto" },
                renderMessage(),
                react_1["default"].createElement(box_1["default"], { padding: "0px", flexDirection: "column" },
                    react_1["default"].createElement(box_1["default"], { padding: "0px" },
                        react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Enter Prompt Name"),
                        renderMandatoryChar()),
                    react_1["default"].createElement(NameInputWrapper, { themed: true, placeholder: " ", value: name, onChange: function (value) {
                            return dispatch({ type: constants_1.ActionTypes.UPDATE_NAME, data: value });
                        } })),
                react_1["default"].createElement(ActiveStatusWrapper, null,
                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Active"),
                    react_1["default"].createElement(toggle_1["default"], { value: active, onChange: function () { return onActiveChange(); } })),
                react_1["default"].createElement(SectionWrapper, null,
                    react_1["default"].createElement(box_1["default"], { padding: "0px" },
                        react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Enable the social channels"),
                        renderMandatoryChar(true)),
                    react_1["default"].createElement(SortableChannelsWrapper, { onSortEnd: sortHandler, helperClass: "dragging-helper-class", useDragHandle: true }, social_prompt.channels.map(function (channel, index) { return (react_1["default"].createElement(SortableChannelItem, { index: index, type: channel.type, title: constants_1.SOCIAL_CHANNELS.TITLE[channel.type], icon: constants_1.SOCIAL_CHANNELS.ICONS[channel.type], active: channel.enabled, isDisabled: isChannelDisabled(channel.type), onChange: function (value) { return onChannelChangeHandler(value); } })); }))),
                react_1["default"].createElement(SectionWrapper, null,
                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Prompt Rule Type"),
                    react_1["default"].createElement(box_1["default"], { padding: "0", marginTop: "8px" },
                        react_1["default"].createElement(radio_1["default"], { themed: true, value: clauseOption, onChange: function (option) {
                                return dispatch({
                                    type: constants_1.ActionTypes.UPDATE_RULES,
                                    data: {
                                        clause: option.value,
                                        rule_list: rules.rule_list,
                                    },
                                });
                            }, options: constants_1.CLAUSE_OPTIONS, optionKey: "title" }))),
                react_1["default"].createElement(SectionWrapper, null,
                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Prompt Rules"),
                    react_1["default"].createElement(NewRuleButtonWrapper, { themed: true, variant: "secondary", onClick: onAddRule },
                        react_1["default"].createElement(AddIconWrapper, { src: AddIcon_svg_1["default"] }),
                        "Add New Rule"),
                    react_1["default"].createElement(box_1["default"], { padding: "0px", marginBottom: "24px", flexDirection: "column" }, rules.rule_list.map(function (rule, index) { return (react_1["default"].createElement(TriggerRule_1["default"], { variable: rule.variable, operator: rule.operator, value: rule.value, meta: rule.meta, onChange: function (key, value) { return onChangeRule(index, key, value); }, onRemove: function () { return onRemove(index); }, attachTo: modalRef })); })))),
            react_1["default"].createElement(PreviewAndEdit_1["default"], { social_prompt: getActiveChannelsData(), onChange: onSocialPromptDataChange }))));
};
exports["default"] = SocialTriggerModal;
var templateObject_1, templateObject_2;
